import React from 'react';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { JobService, JobSummary, Utils } from '@enrich/shared-lib';
import { BulkMessageButton } from '../components/BulkMessageButton';

export const ClientJobSummary = () => {
    const { companySlug, jobId } = useParams();
    const navigate = useNavigate();
    const { candidacyStatusEnums = [] } = useLoaderData();
    const clientCandidacyStatusEnums =
        Utils.filterClientCandidacyStatuses(candidacyStatusEnums);

    const handleCloseJob = async () => {
        const result = await new JobService().closeJob(jobId);
        if (!result) {
            throw new Error('Failed to close job. Please try again.');
        }
        navigate(`/${companySlug}/jobs`);
    };

    const handleChangeJobStatus = async (status) => {
        await new JobService().updateJobStatus(jobId, status);
        window.location.reload();
    };

    const handleUpdateApplicationLink = async (applicationLink) => {
        await new JobService().updateApplicationLink(jobId, applicationLink);
        window.location.reload();
    };

    const handleUpdateApplicationLinkAndOpen = async (applicationLink) => {
        const linkResult = await new JobService().updateApplicationLink(
            jobId,
            applicationLink,
        );
        if (!linkResult) {
            throw new Error(
                'Failed to save application link. Please try again.',
            );
        }

        const statusResult = await new JobService().updateJobStatus(
            jobId,
            'open',
        );
        if (!statusResult) {
            throw new Error('Failed to open job. Please try again.');
        }

        window.location.reload();
    };

    return (
        <JobSummary
            showAdminActions={false}
            showCandidacyEdit={true}
            showDocumentUpload={true}
            showCaseStudyUpload={true}
            candidacyStatusEnums={clientCandidacyStatusEnums}
            onCloseJob={handleCloseJob}
            onChangeJobStatus={handleChangeJobStatus}
            onUpdateApplicationLink={handleUpdateApplicationLink}
            onUpdateApplicationLinkAndOpen={handleUpdateApplicationLinkAndOpen}
            renderMessageButton={(jobData) => (
                <BulkMessageButton
                    candidacyStatusEnums={clientCandidacyStatusEnums}
                    companySlug={companySlug}
                    job={jobData}
                />
            )}
        />
    );
};
